import axios from "axios";

const AxiosRequest = async (method, url, data) => {
  const store = JSON.parse(window.localStorage.redux);
  const token = store.clinician.data.token;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  switch (method) {
    case "get":
      return await axios[method](url, config);
    case "post":
      return await axios[method](url, data, config);
    case "put":
      return await axios[method](url, data, config);
    default:
      break;
  }
};

export default AxiosRequest;
